/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    ADMIN_DASHBOARD_SCHEDULER_HERO
 * Date:         2026-01-05
 * Modified By:  Cursor
 *
 * Description:
 * Surface the new scheduler hero cards and delegate the section grid to an extracted
 * component in order to stay within file size constraints.
 *
 * File Size Check:
 * - Current: 240 lines
 * - Adding: ~25 lines
 * - Projected: 265 lines
 * - Decision: Split First
 *
 * Related Screens / Modules:
 * - client/src/features/admin/scheduler/SchedulerHeroCards.tsx
 * - client/src/pages/admin/components/AdminDashboardSections.tsx
 */
/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    REMOVE_HERO_SECTION_ADD_TO_REGULAR
 * Date:         2026-01-05
 * Modified By:  Cursor
 *
 * Description:
 * Remove the separate scheduler hero section and surface those cards within
 * the regular admin sections grid to simplify the layout as requested.
 *
 * File Size Check:
 * - Current: 240 lines
 * - Adding: ~6 lines
 * - Projected: 246 lines
 * - Decision: Proceed (no large additions)
 *
 * [2026-01-05] UI change: Eliminated hero row and rely on AdminDashboardSections
 */
/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    FIX_ADMIN_LOGS_NAVIGATION
 * Date:         2025-12-14
 * Modified By:  Cursor
 *
 * Description:
 * Fix navigation paths for System Logs and Logins/Sessions cards to ensure correct routing.
 * Add clarifying comments to distinguish between the two similar-sounding cards.
 *
 * Related Screens / Modules:
 * - client/src/pages/admin/AdminDashboard.tsx
 * - client/src/pages/admin/LogsPage.tsx
 * - client/src/pages/admin/LoginsPage.tsx
 */

/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    ADMIN_ACTIVITY_DASHBOARD_CARD
 * Date:         2025-01-15
 * Modified By:  Cursor
 *
 * Description:
 * Added Activity card to admin dashboard to provide quick access to admin activity logs.
 *
 * Related Screens / Modules:
 * - client/src/pages/admin/AdminDashboard.tsx
 * - client/src/features/admin/activity/AdminActivityPage.tsx
 */
/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    PHASE3_ADMIN_CARDS
 * Date:         2025-12-20
 * Modified By:  Cursor
 *
 * Description:
 * Added 3 new admin cards for Phase 3 features:
 * - Monitoring (transaction traces)
 * - Analytics (charts and insights)
 * - Enhanced System Logs (search and filter)
 *
 * Related Modules:
 * - client/src/services/admin/adminStats.ts (fetch stats)
 * - server/services/admin/statsService.js (backend stats)
 */

import React from "react";
import AdminDashboardSections from "./components/AdminDashboardSections";

const AdminDashboard: React.FC = () => {
  return (
    <div className="admin-dashboard-shell">
      {/* [2026-01-05] Admin layout: Render only the consolidated section grid (hero removed) */}
      <AdminDashboardSections />
    </div>
  );
};

export default AdminDashboard;
